<script lang="ts" setup>
import { computed, ComputedRef, Ref, ref } from 'vue';
import BaseModal from './BaseModal.vue';

const emit = defineEmits(['exit', 'credentials']);
const props = defineProps({
	isUIBusy: Boolean,
	loginOperation: String
});

const username: Ref<string> = ref('');
const password: Ref<string> = ref('');

const loginMessage: ComputedRef<string> = computed(() => {
	switch (props.loginOperation) {
		case 'active':
			return 'Logging in to Acumatica';
		case 'failed':
			return 'Login failed. Please try again';
		default:
			return '';
	}
});
</script>

<template>
	<BaseModal @close="emit('exit')">
		<form class="login-form" @submit.prevent="emit('credentials', username, password)">
			<p>
				<span style="display: block"><b>Login To Acumatica</b></span>
				<span><i>Your user session has expired or does not exist</i></span>
			</p>
			<div class="login-form__fields">
				<label for="username">Username:</label>
				<input class="modal" id="username" v-model="username" />
				<label for="password">Password:</label>
				<input class="modal" id="password" type="password" v-model="password" />
			</div>
			<div class="login-form__actions">
				<button class="light" type="submit" :disabled="isUIBusy">Login</button>
				<button class="light" type="button" @click="emit('exit')" :disabled="isUIBusy">Cancel</button>
			</div>
			<div class="login-form__operationInfo">
				<p v-if="loginOperation">{{ loginMessage }}</p>
			</div>
		</form>
	</BaseModal>
</template>

<style>
.login-form {
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding-top: 3px;
}

.login-form__actions {
	display: flex;
	justify-content: center;
	gap: 8px;
}

.login-form__fields {
	display: grid;
	grid-template-columns: max-content 1fr;
	column-gap: 8px;
	row-gap: 3px;
}

.login-form__operationInfo {
	text-align: center;
}
</style>
